import React, { useState, useCallback, useEffect } from "react";
import Search from "../../../../molecules/search";
import CustomButton from "../../../../atoms/CustomButton";
import CustomDataGrid from "../../../../organisms/CustomDatagrid";
import { useCookies } from "react-cookie";
import { getData } from "../../../../../services";
import VerticalMenu from "../../../../icons/VerticalMenu";
import CustomMenu from "../../../../atoms/CustomMenu";
import View from "../../../../icons/View";
import Edit from "../../../../icons/Edit";
import Delete from "../../../../icons/Delete";
import DeleteModal from "../../../../organisms/modals/DeleteModal";
import { deleteData } from "../../../../../services";
import SideOverlay from "../../../../atoms/SideOverlay";
import { v4 as uuidv4 } from "uuid";
// import Form from "./Form";
import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
  getClientList,
  getTeamsList,
} from "../../../../../services/basicGets";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../../assets/styles/toast";
import ViewDetails from "../../activities/view";
import Pagination from "../../../../molecules/Pagination";
import StatusBackground from "../../../../atoms/StatusBackground";
import ColorDots from "../../../../atoms/ColorDots";
import NoContentCard from "../../../../atoms/NoContentCard";
import NoContentIcon from "../../../../icons/NocontentIcon";
import { Select, MenuItem } from "@mui/material";
import { ProjectStatus, Priorities } from "../../../../../helpers/staticData";
import CommonFilter from "../../../../atoms/CommonFilter";

const EmployeeProjects = () => {
  const priorityOptions = ["Low", "Medium", "High", "Critical"];
  const statusOptions = ["Ongoing", "Closed"];
  const [filters, setFilters] = useState({});
  const [cookies] = useCookies(["e_t"]);
  const [selectedRow, setSelectedRow] = useState();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchedValue, setSearchedValue] = useState();
  const [roles, setRoles] = useState([]);
  const [Teams, setTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const [Employee, setEmployee] = useState(null);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    isViewModalOpen: false,
    modalId: "",
    name: "",
  });

  const filterOptions = [
    {
      id: "status",
      label: "Status",
      type: "multi-select",
      options: ProjectStatus,
    },
    {
      id: "priority",
      label: "Priority",
      type: "multi-select",
      options: Priorities,
    },
  ];

  const getProjectsData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "Project/getAllProjects",
        params: {
          employee_id : cookies.euid,
          search_query: searchedValue,
          page: currentPage,
          limit: itemsPerPage,
          priority: JSON.stringify(filters?.priority),
          status: JSON.stringify(filters?.status),
          // business_id: cookies.bid,
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res?.data);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue, filters]);

  useEffect(() => {
    getProjectsData();
  }, [getProjectsData]);

  useEffect(() => {
    (async () => {
      const resRoles = await getRolesList({
        token: cookies.e_t,
      });
      const empRoles = await getEmployeeList({
        token: cookies.e_t,
      });
      const clientRoles = await getClientList({
        token: cookies.e_t,
      });
      const teamRoles = await getTeamsList({
        token: cookies.e_t,
      });
      setTeams(teamRoles);
      setClient(clientRoles);
      setEmployee(empRoles);
      setRoles(resRoles);
    })();
  }, []);

  //   Menu

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menu = [
    {
      icon: <View height="20" width="20" />,
      label: "View Tasks",
      onClick: () => {
        setAnchorEl(null);
        handleView(selectedRow);
      },
    },
    // {
    //   icon: <Edit height="20" width="20" />,
    //   label: "Edit",
    //   onClick: () => {
    //     setAnchorEl(null);
    //     handleEdit(selectedRow);
    //   },
    // },
    // {
    //   icon: <Delete />,
    //   label: "Delete",
    //   onClick: () => {
    //     setAnchorEl(null);
    //     handleDeleteModal(selectedRow);
    //   },
    // },
  ];

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Project",
    }));
  };

  const handleView = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isViewModalOpen: true,
      modalId: data.invite_id,
      data: data,
      name: data?.visitor_name,
    }));
  };
  // ------------------------------------------------

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: true,
    },
    {
      field: "clientName",
      headerName: "Client",
      flex: 0.7,
    },
    {
      field: "priority",
      headerName: "Priority",
      flex: 0.5,
      sortable: true,
      renderCell: (params) => {
        return <ColorDots priority={params.value} />;
      },
      editable: true, // Enable editing
      renderEditCell: (params) => (
        <Select
          value={params.value}
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
          fullWidth
          className="editable-select"
        >
          {priorityOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "ownersInfo",
      headerName: "Project owner",
      flex: 0.8,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.ownersInfo
              ?.filter((owner) => owner.owner_name?.trim()) 
              .reduce((acc, owner) => {
                if (!acc.some((o) => o.owner_id === owner.owner_id)) {
                  acc.push(owner);
                }
                return acc;
              }, [])
              .map((owner) => owner.owner_name)
              .join(", ")}
          </>
        );
      },
    },
    {
      field: "teamInfo",
      headerName: "Assigned Team",
      flex: 1,
      renderCell: (params) => {
        return (
          <>{params?.row?.teamInfo?.map((team) => team.teamName).join(", ")}</>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      sortable: true,
      renderCell: (params) => {
        return <StatusBackground status={params.value} />;
      },
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value}
          className="editable-select"
          onChange={(e) =>
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: e.target.value,
            })
          }
          fullWidth
        >
          {statusOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.2,
      renderCell: (params) => {
        return (
          <div className="table-icons-container">
            <div onClick={(event) => handleStatusMenu(event, params.row)}>
              <VerticalMenu />
            </div>

            <CustomMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              items={menu}
            />
          </div>
        );
      },
    },
  ];

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
    }));
  };

  const handleDeletion = async () => {
    try {
      await deleteData({
        endpoint: "Project/DeleteProject",
        params: {
          project_id: modalState?.modalId,
        },
      });
      toast.error("Project Deleted Sucessfully", {
        style: errorStyles,
        duration: 1000,
      });
      getProjectsData();
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    } catch (error) {
      toast.error("An Error Occured While Deleting", {
        style: errorStyles,
        duration: 1000,
      });
      console.log(error);
    }
  };

  //  Modal Handling  ---------------
  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = () => {
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        <NoContentCard
          title="No Projects Found"
          type="Project"
          subtitle={
            "You haven’t started any projects yet. Create one to get going!"
          }
        />
      </>
    );
  });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <div id="Project-Management" className="main-container">
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2">
          <Search
            placeholder="Search"
            onSearchEmit={(item) => setSearchedValue(item)}
          />
          <CommonFilter
            filters={filterOptions}
            onFilterChange={handleFilterChange}
          />
        </div>
        {/* <CustomButton
          text="Create Project"
          type="btn-primary"
          handleClick={() => openModal("Create Project")}
        /> */}
      </div>
      <div className="mt-3">
        <CustomDataGrid

          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.projects || []}
        />
      </div>

      {modalState?.isModalOpen && (
        <SideOverlay
          id={modalState?.modalId}
          title={modalState.title}
          onClose={closeModal}
          isOpen={modalState?.isModalOpen}
          side="right"
          width="550px"
        >
          {/* <Form
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "Edit Project" ? modalState.modalData : null
            }
            employeeList={Employee}
            rolesList={roles}
            clientList={Client}
            teamList={Teams}
            refetchData={getProjectsData}
            onClose={() => closeModal("submit")}
          /> */}
        </SideOverlay>
      )}

      {tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalState.isViewModalOpen && (
        <SideOverlay
          // name={modalState.name}
          title={modalState?.data?.name}
          id={modalState.modalId}
          isOpen={modalState.isViewModalOpen}
          isLoading={false}
          side="right"
          width="550px"
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isViewModalOpen: false,
            }))
          }
        >
          <ViewDetails data={modalState.data} />
        </SideOverlay>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="Project"
          onClick={handleDeletion}
        />
      )}
    </div>
  );
};

export default EmployeeProjects;
